<template>
	<div class="reward-frame-wrapper">
		<svg
			width="100%"
			height="100%"
			xmlns="http://www.w3.org/2000/svg"
			class="reward-frame"
		>
			<defs>
				<linearGradient
					id="gold-side-v"
					x1="0"
					y1="0.5"
					x2="1"
					y2="0.5"
				>
					<stop stop-color="#3A1C0E" />
					<stop offset="0.33" stop-color="#C09252" />
					<stop offset="0.5" stop-color="#E9BF76" />
					<stop offset="0.66" stop-color="#C09252" />
					<stop offset="1" stop-color="#3A1C0E" />
				</linearGradient>

				<linearGradient
					id="gold-corner-h"
					x1="0.5"
					y1="0"
					x2="0.5"
					y2="1"
				>
					<stop stop-color="#8C5C29" />
					<stop offset="0.15" stop-color="#D39F57" />
					<stop offset="0.35" stop-color="#E9BF76" />
					<stop offset="0.65" stop-color="#D39F57" />
					<stop offset="1" stop-color="#3F2716" />
				</linearGradient>

				<filter id="bg-texture">
					<feTurbulence
						type="fractalNoise"
						baseFrequency="0.9"
						numOctaves="2"
						result="noise"
					/>
					<feBlend mode="overlay" in="SourceGraphic" in2="noise" />
				</filter>
			</defs>

			<rect
				x="2"
				y="2"
				width="calc(100% - 4px)"
				height="calc(100% - 4px)"
				fill="#0C141D"
				filter="url(#bg-texture)"
				class="bg-texture"
			/>

			<rect
				x="10"
				y="0"
				width="calc(100% - 20px)"
				height="4"
				fill="url(#gold-corner-h)"
			/>
			<rect
				x="10"
				y="calc(100% - 4px)"
				width="calc(100% - 20px)"
				height="4"
				fill="url(#gold-corner-h)"
			/>
			<rect
				x="0"
				y="10"
				width="4"
				height="calc(100% - 20px)"
				fill="url(#gold-side-v)"
			/>
			<rect
				x="calc(100% - 4px)"
				y="10"
				width="4"
				height="calc(100% - 20px)"
				fill="url(#gold-side-v)"
			/>

			<svg x="0" y="0" width="10" height="10" viewBox="0 0 10 10">
				<path
					d="M0 0 H10 V4 H4 V10 H0 V0 Z"
					fill="url(#gold-corner-h)"
				/>
			</svg>
			<svg
				x="calc(100% - 10px)"
				y="0"
				width="10"
				height="10"
				viewBox="0 0 10 10"
				class="corner--bottom-right"
			>
				<path
					d="M0 0 H10 V10 H6 V4 H0 V0 Z"
					fill="url(#gold-corner-h)"
				/>
			</svg>
			<svg
				x="0"
				y="calc(100% - 10px)"
				width="10"
				height="10"
				viewBox="0 0 10 10"
				class="corner--bottom-left"
			>
				<path
					d="M0 0 H4 V6 H10 V10 H0 V0 Z"
					fill="url(#gold-corner-h)"
				/>
			</svg>
			<svg
				x="calc(100% - 10px)"
				y="calc(100% - 10px)"
				width="10"
				height="10"
				viewBox="0 0 10 10"
			>
				<path
					d="M6 0 H10 V10 H0 V6 H6 V0 Z"
					fill="url(#gold-corner-h)"
				/>
			</svg>

			<rect
				x="4"
				y="4"
				width="calc(100% - 8px)"
				height="calc(100% - 8px)"
				stroke="#E9BF76"
				stroke-width="0.3"
				fill="none"
				opacity="0.3"
				vector-effect="non-scaling-stroke"
			/>
		</svg>

		<div class="box-decoration">
			<div class="reward-box-corner--top-left-20 top-left" />
			<div class="reward-box-corner--top-right-20 top-right" />
			<div class="reward-box-corner--bottom-left-20 bottom-left" />
			<div class="reward-box-corner--bottom-right-20 bottom-right" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
.reward-frame-wrapper {
	position: relative;
	width: 100%;
	height: 100%;

	.reward-frame {
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		overflow: hidden;

		.corner--bottom-left {
			position: absolute;
			bottom: 0;
			left: 0;
		}

		.corner--bottom-right {
			position: absolute;
			right: 0;
			bottom: 0;
		}
	}

	.content {
		position: relative;
		z-index: 1;
		padding: 12px;
	}

	.bg-texture {
		opacity: 0.3;
	}

	.box-decoration {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 0;
		width: 100%;
		height: 100%;

		.top-left {
			position: absolute;
			top: 0;
			left: 0;
		}

		.top-right {
			position: absolute;
			top: 0;
			right: 0;
		}

		.bottom-left {
			position: absolute;
			bottom: 0;
			left: 0;
		}

		.bottom-right {
			position: absolute;
			right: 0;
			bottom: 0;
		}
	}
}
</style>
